import { render, staticRenderFns } from "./addControl.vue?vue&type=template&id=8f51fe4a"
import script from "./addControl.vue?vue&type=script&lang=js"
export * from "./addControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports